<div class="grid-container" *ngIf="!isDelegationRoute">
    <div class="row" style="display: none" *ngIf="screenSize === 'xs'; then mobileBlock; else webBlock"></div>

    <ng-template #mobileBlock>
        <div class="col-12">
            <div class="sidebar-nav col-12">
                <app-sidebar-menu [screenSize]="screenSize" [sideMenuList]="sideMenuList"></app-sidebar-menu>
            </div>
            <div class="grid-item" *ngIf="showBodyContent">
                <div class="body-content custom-visible-scroll" #scrollEl>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #webBlock>
        <div id="right" class="sidebar-nav">
            <app-sidebar-menu [sideMenuList]="sideMenuList"></app-sidebar-menu>
        </div>
        <div id="left" class="grid-item" *ngIf="showBodyContent">
            <div class="body-content custom-visible-scroll" #scrollEl>
                <router-outlet></router-outlet>
            </div>
        </div>
    </ng-template>

    <div class="loader-container" *ngIf="showLoader">
        <div class="loader">
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>

    <div class="loader-container entire-screen-overlay-loader" *ngIf="showLoaderOverlay">
        <div class="loader">
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</div>

<!-- For delegation routes, use a simplified layout with just the router outlet -->
<div class="full-width-container" *ngIf="isDelegationRoute">
    <div class="loader-container" *ngIf="showLoader">
        <div class="loader">
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>

    <div class="content" *ngIf="showBodyContent">
        <router-outlet></router-outlet>
    </div>

    <div class="loader-container entire-screen-overlay-loader" *ngIf="showLoaderOverlay">
        <div class="loader">
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</div>
